var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["category/templates/facets/category-facets-reset.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/urls.j2", false, "category/templates/facets/category-facets-reset.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("genericUrl")) {
var t_4 = t_1.genericUrl;
} else {
cb(new Error("cannot import 'genericUrl'")); return;
}
context.setVariable("genericUrl", t_4);
output += "\n\n";
var t_5;
t_5 = (((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"facetOptions")),"totalSelectedFacets") || runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"isSortSelected")) && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"queryString"))?"c-facets__reset":"c-facets__reset c-facets__reset--disabled");
frame.set("resetClass", t_5, true);
if(frame.topLevel) {
context.setVariable("resetClass", t_5);
}
if(frame.topLevel) {
context.addExport("resetClass", t_5);
}
output += "\n";
var t_6;
t_6 = (((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"facetOptions")),"totalSelectedFacets") || runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"isSortSelected")) && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"queryString"))?"":(lineno = 3, colno = 127, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["category_aria-reset-facets-disabled"])));
frame.set("ariaLabel", t_6, true);
if(frame.topLevel) {
context.setVariable("ariaLabel", t_6);
}
if(frame.topLevel) {
context.addExport("ariaLabel", t_6);
}
output += "\n\n<div class=\"c-facets-container__footer-section\">\n\t<a class=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "resetClass"), env.opts.autoescape);
output += " js-facets-reset\" data-facets-reset=\"";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"facetOptions")),"reset")),"queryString")), env.opts.autoescape);
output += "\" href=\"";
output += runtime.suppressValue((lineno = 6, colno = 127, runtime.callWrap(t_4, "genericUrl", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"catalogRequestPathname"),runtime.makeKeywordArgs({"excludeContextPath": runtime.contextOrFrameLookup(context, frame, "True")})])), env.opts.autoescape);
output += "\" aria-label=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "ariaLabel"), env.opts.autoescape);
output += "\" data-qa-reset-all-link>\n\t\t";
output += runtime.suppressValue((lineno = 7, colno = 4, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["category_reset-facets"])), env.opts.autoescape);
output += "\n\t</a>\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["category/templates/facets/category-facets-reset.j2"] , dependencies)